export const ShareTabIds = {
  SHARE_LINK_TAB: 'shareLinkTab',
  EMBED_CODE_TAB: 'embedCodeTab',
  DEVELOPER_CODE_TAB: 'developerCodeTab',
  HUBSPOT_TAB: 'hubspotTab'
};